import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from './utils/getCookie';
import { decryptToken } from './utils/getToken';

const AttributeModal = ({ isOpen, setIsOpen, fetchData, selectedAttribute, isEdit }) => {
    const [name, setName] = useState('');
    const [status, setStatus] = useState(null);
    const urlmain = process.env.REACT_APP_LINK
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    useEffect(() => {
        if (isEdit && selectedAttribute) {
            setName(selectedAttribute.name || '');
            setStatus(statusOptions.find(opt => opt.value === selectedAttribute.status));
        } else {
            setName('');
            setStatus(null);
        }
    }, [selectedAttribute, isEdit]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                name,
                status: status?.value || '',
                user_id: user.main_id,
                user_name: user.full_name || 'Admin'
            };

            const url = isEdit
                ? `${urlmain}/attribute/single/${selectedAttribute.id}`
                : `${urlmain}/attribute/admin1997`;

            const method = isEdit ? 'PUT' : 'POST';

            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload)
            });

            const res = await response.json();
            if (response.ok) {
                toast.success(isEdit ? "Attribute updated" : "Attribute created", { position: "top-center", autoClose: 2000 });
                fetchData();
                setIsOpen(false);
            }
        } catch (error) {
            toast.error("Something went wrong", { position: "top-center", autoClose: 2000 });
        }
    };

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">{isEdit ? "Edit Attribute" : "Attribute Details"}</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label>Name</label>
                        <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className="oms-form-group">
                        <label>Status</label>
                        <Select options={statusOptions} value={status} onChange={setStatus} />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        <button type="submit">{isEdit ? "Update" : "Submit"}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};


export default AttributeModal;
